import { attr } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

// Subscription onboarding requires that we have an authneticated customer
// This is why we extend from the base Application record unlike the other
// onboarding record classes.

const Subscription = ApplicationRecord.extend({
  attrs: {
    customer_id: attr({ type: Number }),
    first_delivery_date: attr(),
    first_delivery_recipe_ids: attr({ type: Array }),
    excluded_food_groups: attr({ type: Array }),
    meal_plan: attr({ type: String }),
    portion_count_per_meal: attr({ type: Number }),
    payment_token: attr({ type: String }),
  },
  static: {
    apiNamespace: '/onboardings',
    endpoint: '/subscriptions',
    jsonapiType: 'onboardings-subscriptions',
  },
});

export default Subscription;
